export default "__VITE_ASSET__b$sGRZl9__"